import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const AttachIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Attach",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M20.66 11.97a1.52 1.52 0 1 0-2.16-2.14l-7.49 7.49c-.57.65-.92 1.5-.92 2.44 0 2.04 1.66 3.7 3.7 3.7.93 0 1.77-.34 2.42-.9s10.82-10.82 10.82-10.82a5.88 5.88 0 0 0 1.42-3.84 5.898 5.898 0 0 0-9.75-4.47S5.91 16.21 5.91 16.21a8.05 8.05 0 0 0-2.36 5.71c0 4.47 3.62 8.09 8.09 8.09 2.24 0 4.26-.91 5.72-2.38l9.47-9.47a1.52 1.52 0 0 0-2.15-2.15l-9.47 9.46c-.92.94-2.2 1.53-3.61 1.53-2.78 0-5.04-2.25-5.04-5.04 0-1.42.59-2.7 1.53-3.61S20.88 5.56 20.88 5.56a2.83 2.83 0 0 1 2.07-.89c1.58 0 2.85 1.28 2.85 2.85 0 .81-.34 1.55-.88 2.06S14.1 20.4 14.1 20.4a.702.702 0 0 1-.99-.99l7.55-7.47Z"
      })
    }) : /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M10.81 26.26c-1.74 0-3.49-.66-4.81-1.99s-1.99-3-1.99-4.81.71-3.53 1.99-4.81l6.84-6.84a.996.996 0 1 1 1.41 1.41l-6.84 6.84C6.5 16.97 6 18.18 6 19.46s.5 2.49 1.41 3.4c1.87 1.87 4.92 1.87 6.8 0l10.95-10.95a2.873 2.873 0 0 0 0-4.06 2.873 2.873 0 0 0-4.06 0L10.15 18.8c-.36.37-.36.96 0 1.32.35.35.97.35 1.32 0l6.84-6.84a.996.996 0 1 1 1.41 1.41l-6.84 6.84c-1.11 1.11-3.04 1.11-4.15 0a2.945 2.945 0 0 1 0-4.15L19.68 6.43c1.9-1.9 4.99-1.9 6.89 0s1.9 4.99 0 6.89L15.62 24.27a6.78 6.78 0 0 1-4.81 1.99"
      })
    })
  }));
};